import _ from 'lodash';

import { useAppLauncherStore } from './use-app-launcher-store';
import { useAppLauncherRouting } from './use-app-launcher-routing';
import { useInitializeData } from './use-initialize-app-launcher';
import { AppLauncherSettings } from '../types';
import { APP_STATES } from '../constants';

export const useCommonActions = () => {
  const store = useAppLauncherStore();
  const { goTo, goToAppLauncher } = useAppLauncherRouting();
  const { saveAPIAppLauncherSettings } = useInitializeData();

  /** Save current settings in store in the database */
  const onSaveAppLauncherSettings = async () => {
    try {
      store.isSavingSettings = true;
      await saveAPIAppLauncherSettings(store.settings);

      store.settingsInDB = _.cloneDeep(store.settings);
      store.isSavingSettings = false;
    } catch (e: any) {
      store.error = e;
      store.isSavingSettings = false;
      console.error('Error while saving launcher settings to the DB!', e);
    }
  };

  const onAcceptVersion = async () => {
    const appVersion = store.maxVersionByActiveMigration;
    store.settings = { ...store.settings, appVersion };

    await onSaveAppLauncherSettings();
    goTo({ state: APP_STATES.APP_SETTINGS });
  };

  const onSettingsChange = (settings: AppLauncherSettings) => {
    store.settings = settings;
    if (store.needsDataUpdate) {
      goTo({ state: APP_STATES.NEEDS_DATA_UPDATE });
    }
  };

  /** We know we had to request settings in order to be able to change version */
  const onClearChanges = () => {
    store.settings = _.cloneDeep(store.settingsInDB);
    goToAppLauncher({ skipInitialization: true });
  };

  return {
    onSettingsChange,
    onClearChanges,
    onSaveAppLauncherSettings,
    onAcceptVersion,
  };
};
